import Filters from "./Filters/Filters.jsx";
import Product from "./Product/Product.jsx";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCommonProducts } from "../../../redux/commonProductActions.js";
import style from "./CommonsCatalogue.module.css";

const CommonsCatalogue = () => {

    const dispatch = useDispatch();
    const commonProductsCopy = useSelector(state => state.commonProducts.commonProductsCopy);

    useEffect(() => {
        dispatch(getCommonProducts());
    }, [dispatch]);

    //----- PAGINADO
        
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;
    const [paginatedProducts, setPaginatedProducts] = useState([]);

    useEffect(() => {
        if (Array.isArray(commonProductsCopy)) {
            const newPageData = commonProductsCopy.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
            );

            setPaginatedProducts((prev) => {
                const prevStringified = JSON.stringify(prev);
                const newStringified = JSON.stringify(newPageData);

                return prevStringified === newStringified ? prev : newPageData;
            });
        }
    }, [commonProductsCopy, currentPage, itemsPerPage]);

    const totalPages = Math.ceil(commonProductsCopy.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const getPageButtons = () => {
        const buttons = [];
        let startPage, endPage;

        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`pageButton ${currentPage === i ? 'currentPage' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };

    return(
        <div className={style.div}>
            <h2>Stock <span>permanente</span></h2>
            <h4>Algunos de nuestros productos siempre disponibles</h4>
            <Filters/>
            <div className="paginationContainer">
                <div className="pagination">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        ◂
                    </button>
                    {getPageButtons()}
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        ▸
                    </button>
                </div>
            </div>
            <div className={style.cards}>
                {paginatedProducts.map(commonProduct => (
                    <div className={style.card}>
                        <Product
                            key={commonProduct.id}
                            id={commonProduct.id}
                            brand={commonProduct.brand}
                            category={commonProduct.category}
                            image={commonProduct.image}
                            description={commonProduct.description}
                        />
                    </div>
                ))}
            </div>
            <div className="paginationContainer">
                <div className="pagination">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        ◂
                    </button>
                    {getPageButtons()}
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        ▸
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CommonsCatalogue;